<div mat-dialog-title i18n="@@profileView.reportDialog.title">
  Reporting profile
</div>
<mat-dialog-content i18n="@@profileView.reportDialog.content">
  Are you sure you want to report this profile?
</mat-dialog-content>
<mat-dialog-actions fxLayout="row" fxLayoutAlign="end center">
  <button i18n="@@global.no" mat-button [mat-dialog-close]="false">No</button>
  <button
    i18n="@@global.yes"
    mat-raised-button
    color="primary"
    [mat-dialog-close]="true"
  >
    Yes
  </button>
</mat-dialog-actions>
